import styled from 'styled-components'

const Container = styled.div`
	width: 100%;
	flex: 1;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	flex-direction: row;

	background-color: ${p => (p.background === 'light-grey' ? '#F6F6F6' : 'initial')};
`

export default Container
